import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { Utility } from '../../../common/utility';
import { ValidationService } from '../../../shared/services/validation.service';
import { Patient } from '../../../models/patient/patient.model'
import { AdminVaccineService } from './../admin-vaccine.service'
import { Subject } from 'rxjs/Subject';
import { BaseUrl } from '../../../shared/urls/base.url';
import * as moment from 'moment';
import { ShareService } from '../../../shared/services/share.service';
import { PatientUrl } from '../../../shared/urls/patient.url';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
@Component({
  selector: 'admin-vaccine-received',
  templateUrl: './admin-vaccine-received.component.html',
  providers: [AdminVaccineService, ShareService]
})
export class AdminVaccineReceivedComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  public appConstants = AppConstants;
  public isFunc = true;
  public userId = localStorage.getItem(this.appConstants.activeLink.userId);

  constructor(
    public utility: Utility,
    private formBuilder: FormBuilder,
    public baseService:BaseService,
    public shareServices: ShareService,
    public dialogService:DialogService,
    private router: Router) {}

  ngOnInit() {
    var self = this;
    $.fn.dataTable.ext.errMode = 'throw';
    const url = BaseUrl.BASE_URL +
    PatientUrl.PATIENT_GET_ADMINISTEREDVACCINE;

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      searching: false,
      lengthChange: false,
      retrieve: true,
      serverSide: true,
      processing: true,
      ajax: {
        url: url,
        type: 'GET',
        beforeSend: function (request) {
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Accept', 'application/json');
            request.setRequestHeader('Authorization', 'bearer ' + BaseService.token);
        }
      },
      columns: [{
        title: 'Administer Date',
        data: 'administeredDate',
        render: function(data, type, row) {
          return moment(data).format('DD MMM YYYY');
        }
      }, {
        title: 'Vaccine',
        data: 'vaccineName'
      }, {
        title: 'Clinic',
        data: 'centre'
      },
      // {
      //   title: 'Administered By',
      //   data: 'administeredBy'
      // },
      {
        title: 'Where',
        data: 'where'
      }, {
        title: 'Batch No',
        data: 'batchNo',
      },
      {
        title: 'Action',
        data: 'vaccineId',
        render: function(data, type, row) {
          if (self.isFunc) {
            $('.table-1').on('click', '.action', function(){
              var vaccineId = $(this).attr('attr-id');
              var vaccineName = $(this).attr('vaccineName');
              var consultationId = $(this).attr('vaAdminId');
              self.onExport(vaccineId, consultationId, vaccineName);
            });
            self.isFunc = false;
          }

          return '<a class="action" attr-id ="' + data + '" vaAdminId="' + row.vaAdminId +  '" vaccineName="' + row.vaccineName + '" title="Export Certificate">Export Certificate</a>';
        }
      },
    ],
      language: {
        emptyTable: 'No vaccine record',
        info: 'Total _TOTAL_ vaccine(s)',
        infoEmpty: 'Total 0 vaccine(s)',
        processing: '<img src="../assets/images/spinner.gif" />'
      }
    };


  }

  onExport(vaccineId, consultationId, vaccineName) {
    let msg = Utility.stringFormat(AppMessages.adminVaccine.export, [vaccineName]);
    this.dialogService.openConfirmationDialog({ message: msg }).subscribe(
      result => {
        if (result) {
          this.baseService.getData(ConsultationUrl.GET_PATIENT_MYTMB).subscribe(
            resultPatient => {
              const data = resultPatient.json();
              let param = {
                [AppConstants.reportParameter.patientId] : data.response,
                [AppConstants.reportParameter.vaccineId] : vaccineId,
                [AppConstants.reportParameter.consultationId] : consultationId
              }
              this.shareServices.showReport('StolenVaccinationCertificate', param, null);
              return;
            },
            error => {
              console.log('Export id', vaccineId, this.userId);
              let param = {
                [AppConstants.reportParameter.patientId] : this.userId,
                [AppConstants.reportParameter.vaccineId] : vaccineId,
                [AppConstants.reportParameter.consultationId] : consultationId
              }

              this.shareServices.showReport('StolenVaccinationCertificate', param, null);
            }
          );
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/admin-vaccine/admin-vaccine-received/admin-vaccine-received.component.ts